/**
 * Usage:
 *
 * data-sw-item-purchase-form
 *
 */

var $ = require('./../sw-jquery');
var ItemPurchaseForm = require('./../../lib/views/ItemPurchaseForm.js');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-item-purchase-form]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {

      var spin = $el.data('swItemPurchaseForm');

      var product = ModelManager.getProduct(spin);

      new ItemPurchaseForm({
        el: $el,
        model: product
      });
    });
  });

};
